export default __webpack_public_path__ + "static/media/logo.4e0c4c03.svg";